import { InteractionManager, Platform, AppState } from 'react-native';
export function runOnBackground(fn, options) {
    return new Promise((res, rej) => {
        if (Platform.OS === 'web' || (options === null || options === void 0 ? void 0 : options.useTimeout) || typeof (options === null || options === void 0 ? void 0 : options.timeout) === 'number') {
            setTimeout(() => {
                Promise.resolve(fn())
                    .then(res)
                    .catch(rej);
            }, (options === null || options === void 0 ? void 0 : options.timeout) || 0);
        }
        else {
            InteractionManager.runAfterInteractions(() => {
                Promise.resolve(fn())
                    .then(res)
                    .catch(rej);
            });
        }
    });
}
export function whenAppIsActive() {
    return whenAppChangeState('active');
}
export function whenAppIsInactive() {
    return whenAppChangeState('inactive');
}
export function whenAppIsBackground() {
    return whenAppChangeState('background');
}
export function whenAppChangeState(state) {
    if (AppState.currentState === state) {
        return Promise.resolve();
    }
    return new Promise(res => {
        const sub = AppState.addEventListener('change', state => {
            if (state === state) {
                sub.remove();
                res(undefined);
            }
        });
    });
}
export function waitTimeout(timeout) {
    return new Promise(res => setTimeout(res, timeout || 0));
}
